<template>
  <div class="SearchHead">
    <div>
      <h2>
        {{ props.heading }}
        <span v-if="props.results">({{ props.results }} {{ props.hits }})</span>
      </h2>
      Sida {{ store.page }} av {{ Math.ceil(store.antalObjekt / store.settings.pageSize) }}
    </div>
    <SaveButtons class="desktopOnly" v-show="!isMobile" :vy="props.vy" :url="props.url"
      :isDisabled="store.antalObjekt <= 0 || store.settings.disableDownload"></SaveButtons>
  </div>
</template>
<script lang="ts" setup>
import { defineProps, watchEffect, ref } from 'vue';
import useAstaStore from '../stores/AstaStore';
import SaveButtons from './saveButtons.vue';

const store = useAstaStore();
const isMobile = ref<boolean>(false);
const props = defineProps<{
  heading: string;
  hits: string;
  results: number;
  url: string;
  vy: string;
}>();
watchEffect(() => {
  if (window.innerWidth < 776) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
});
</script>
